import { render } from "./createapplic.vue?vue&type=template&id=69e54b29"
import script from "./createapplic.vue?vue&type=script&lang=js"
export * from "./createapplic.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__